export default {
    socialMedias: []
};
